<template>
  <v-dialog
    v-model="dialog"
    persistent
    width="360"
  >
    <v-card
      tile
      class="pb-3"
    >
      <v-card
        flat
        tile
        dark
        class="d-flex align-center justify-space-between px-3 py-2"
        color="light-blue darken-1"
      >
        <div class="text-body-2 font-weight-bold">
          {{ $t('m.enterCoordinate') }}
        </div>
        <v-btn
          icon
          @click="cancel"
          small
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card>
      <v-card
        tile
        flat
      >
        <v-tabs
          v-model="tab"
          background-color="grey lighten-4"
          dense
          fixed-tabs
          height="40"
        >
          <v-tab
            href="#tab-1"
            class="text-subtitle-2"
          >
            {{ $t('m.lonLatDecimal') }}
          </v-tab>
          <v-tab
            href="#tab-2"
            class="text-subtitle-2"
          >
            {{ $t('m.dm') }}
          </v-tab>
          <v-tab
            href="#tab-3"
            class="text-subtitle-2"
          >
            {{ $t('m.dms') }}
          </v-tab>
        </v-tabs>
        <v-tabs-items v-model="tab">
          <v-tab-item value="tab-1">
            <v-container class="mycon px-6">
              <p class="mb-0 text-subtitle-2">
                {{ $t('m.lonAbbrev') }}
              </p>
              <v-row dense>
                <v-text-field
                  dense
                  hide-details
                  v-model="lon1"
                  type="number"
                />
              </v-row>
              <p class="mt-6 mb-0 text-subtitle-2">
                {{ $t('m.latAbbrev') }}
              </p>
              <v-row dense>
                <v-text-field
                  dense
                  hide-details
                  v-model="lat1"
                  type="number"
                />
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item value="tab-2">
            <v-container class="mycon">
              <p class="mb-0 text-subtitle-2">
                {{ $t('m.lonAbbrev') }}
              </p>
              <v-row dense>
                <v-col cols="4">
                  <v-text-field
                    type="number"
                    hide-details
                    dense
                    v-model="lon2_d"
                    suffix="°"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    type="number"
                    hide-details
                    dense
                    v-model="lon2_m"
                    suffix="′"
                  />
                </v-col>
                <v-col cols="4">
                  <v-select
                    v-model="lon2_a"
                    :items="lonItems"
                    dense
                    hide-details
                  />
                </v-col>
              </v-row>
              <p class="mt-4 mb-0 text-subtitle-2">
                {{ $t('m.latAbbrev') }}
              </p>
              <v-row dense>
                <v-col cols="4">
                  <v-text-field
                    type="number"
                    dense
                    hide-details
                    v-model="lat2_d"
                    suffix="°"
                  />
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    type="number"
                    dense
                    hide-details
                    v-model="lat2_m"
                    suffix="′"
                  />
                </v-col>
                <v-col cols="4">
                  <v-select
                    v-model="lat2_a"
                    :items="latItems"
                    dense
                    hide-details
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>

          <v-tab-item value="tab-3">
            <v-container class="mycon">
              <p class="mb-0 text-subtitle-2">
                {{ $t('m.lonAbbrev') }}
              </p>
              <v-row dense>
                <v-col cols="3">
                  <v-text-field
                    type="number"
                    dense
                    hide-details
                    v-model="lon3_d"
                    suffix="°"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    type="number"
                    dense
                    hide-details
                    v-model="lon3_m"
                    suffix="′"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    type="number"
                    dense
                    hide-details
                    v-model="lon3_s"
                    suffix="″"
                  />
                </v-col>
                <v-col cols="3">
                  <v-select
                    v-model="lon3_a"
                    :items="lonItems"
                    dense
                    hide-details
                  />
                </v-col>
              </v-row>
              <p class="mt-4 mb-0 text-subtitle-2">
                {{ $t('m.latAbbrev') }}
              </p>
              <v-row dense>
                <v-col cols="3">
                  <v-text-field
                    type="number"
                    dense
                    hide-details
                    v-model="lat3_d"
                    suffix="°"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    type="number"
                    dense
                    hide-details
                    v-model="lat3_m"
                    suffix="′"
                  />
                </v-col>
                <v-col cols="3">
                  <v-text-field
                    type="number"
                    dense
                    hide-details
                    v-model="lat3_s"
                    suffix="″"
                  />
                </v-col>
                <v-col cols="3">
                  <v-select
                    v-model="lat3_a"
                    :items="latItems"
                    dense
                    hide-details
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>
      </v-card>

      <v-card
        flat
        tile
        class="d-flex align-center justify-center"
      >
        <v-btn
          color=""
          small
          depressed
          class="mr-6"
          @click="cancel"
        >
          {{ $t('m.cancel') }}
        </v-btn>
        <v-btn
          small
          depressed
          color="brown lighten-3"
          class="mr-6"
          @click="clearLonLat"
        >
          {{ $t('m.clear') }}
        </v-btn>
        <v-btn
          color="primary"
          small
          depressed
          @click="add"
        >
          {{ $t('m.add') }}
        </v-btn>
      </v-card>
    </v-card>

    <v-snackbar v-model="snackbar">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('m.close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-dialog> <!-- end mutiEnteDialog -->
</template>

<script>
import Utils from '@/utils/index'
import _ from 'lodash'

export default {
  name: 'LonLatMultiEnterDlg',
  props: [
    'visible'
  ],
  data () {
    return {
      dialog: false,
      tab: null,
      lonItems: ['E', 'W'],
      latItems: ['N', 'S'],

      lon1: null,
      lat1: null,

      lon2_d: null,
      lon2_m: null,
      lon2_a: 'E',
      lat2_d: null,
      lat2_m: null,
      lat2_a: 'N',

      lon3_d: null,
      lon3_m: null,
      lon3_s: null,
      lon3_a: 'E',
      lat3_d: null,
      lat3_m: null,
      lat3_s: null,
      lat3_a: 'N',

      snackbar: false,
      snackbarText: null
    }
  },

  computed: {
    tap_1 () {
      const { lon1, lat1 } = this
      return {
        lon1, lat1
      }
    },

    tap_2 () {
      const { lon2_d, lon2_m, lon2_a, lat2_d, lat2_m, lat2_a } = this
      return {
        lon2_d,
        lon2_m,
        lon2_a,
        lat2_d,
        lat2_m,
        lat2_a
      }
    },

    tap_3 () {
      const { lon3_d, lon3_m, lon3_s, lon3_a, lat3_d, lat3_m, lat3_s, lat3_a } = this
      return {
        lon3_d,
        lon3_m,
        lon3_s,
        lon3_a,
        lat3_d,
        lat3_m,
        lat3_s,
        lat3_a
      }
    }
  },

  watch: {
    visible: function (val) {
      this.dialog = val
    },

    tap_1: {
      handler (val, old) {
        if (this.tab == 'tab-1') {
          var dmLonObj = Utils.handleDtoDM(val.lon1, 'LON')
          var dmLatObj = Utils.handleDtoDM(val.lat1, 'LAT')

          var dmsLonObj = Utils.handleDtoDMS(val.lon1, 'LON')
          var dmsLatObj = Utils.handleDtoDMS(val.lat1, 'LAT')

          // 度 -> 度分
          this.lon2_d = dmLonObj.d
          this.lon2_m = dmLonObj.m
          this.lon2_a = dmLonObj.abridge

          this.lat2_d = dmLatObj.d
          this.lat2_m = dmLatObj.m
          this.lat2_a = dmLatObj.abridge

          // 度 -> 度分秒
          this.lon3_d = dmsLonObj.d
          this.lon3_m = dmsLonObj.m
          this.lon3_s = dmsLonObj.s
          this.lon3_a = dmsLonObj.abridge

          this.lat3_d = dmsLatObj.d
          this.lat3_m = dmsLatObj.m
          this.lat3_s = dmsLatObj.s
          this.lat3_a = dmsLatObj.abridge
        }
      },
      deep: true
    },

    tap_2: {
      handler (val, old) { // 度分
        if (this.tab == 'tab-2') {
          // 度分 => 度
          this.lon1 = Utils.handleDMtoD(val.lon2_d, val.lon2_m, val.lon2_a, 'LON').d
          this.lat1 = Utils.handleDMtoD(val.lat2_d, val.lat2_m, val.lat2_a, 'LAT').d

          // 度分 => 度分秒
          var lonObj = Utils.handleDMtoDMS(val.lon2_d, val.lon2_m, val.lon2_a, 'LON')
          var latObj = Utils.handleDMtoDMS(val.lat2_d, val.lat2_m, val.lat2_a, 'LAT')

          this.lon3_d = lonObj.d
          this.lon3_m = lonObj.m
          this.lon3_s = lonObj.s
          this.lon3_a = val.lon2_a

          this.lat3_d = latObj.d
          this.lat3_m = latObj.m
          this.lat3_s = latObj.s
          this.lat3_a = val.lat2_a
        }
      },
      deep: true
    },

    tap_3: {
      handler (val, old) {
        if (this.tab == 'tab-3') {
          // 度分秒 => 度
          this.lon1 = Utils.handleDMStoD(val.lon3_d, val.lon3_m, val.lon3_s
            , val.lon3_a, 'LON').d
          this.lat1 = Utils.handleDMStoD(val.lat3_d, val.lat3_m, val.lat3_s
            , val.lat3_a, 'LAT').d

          // 度分秒 => 度分
          var lonObj = Utils.handleDMStoDM(val.lon3_d, val.lon3_m, val.lon3_s
            , val.lon3_a, 'LON')
          var latObj = Utils.handleDMStoDM(val.lat3_d, val.lat3_m, val.lat3_s
            , val.lat3_a, 'LAT')

          this.lon2_d = lonObj.d
          this.lon2_m = lonObj.m
          this.lon2_a = val.lon3_a

          this.lat2_d = latObj.d
          this.lat2_m = latObj.m
          this.lat2_a = val.lat3_a
        }
      },
      deep: true
    }

  },

  methods: {
    cancel () {
      this.snackbar = false
      this.$emit('cancel')
    },

    add () {
      if (this.lon1 == '' || this.lon1 == null || _.isNaN(this.lon1) || !_.isNumber(Number(this.lon1)) ||
          this.lat1 == '' || this.lat1 == null || _.isNaN(this.lat1) || !_.isNumber(Number(this.lat1)) ||
          this.lon1 > 180 || this.lat1 > 90) {
        this.snackbarText = this.$t('m.enterValidLonLat')
        this.snackbar = true
        return
      }

      var o = {}
      o.lon = this.lon1
      o.lat = this.lat1
      o.lonLabel = this.lon2_d + '°' + this.lon2_m + '′ ' + this.lon2_a
      o.latLabel = this.lat2_d + '°' + this.lat2_m + '′ ' + this.lat2_a
      o.no = this.generateUUID(8, 16)

      this.$emit('save', o)
      this.clearLonLat()
    },

    clearLonLat () {
      this.lon1 = null
      this.lat1 = null

      this.lon2_d = null
      this.lon2_m = null
      this.lon2_a = 'E'
      this.lat2_d = null
      this.lat2_m = null
      this.lat2_a = 'N'

      this.lon3_d = null
      this.lon3_m = null
      this.lon3_s = null
      this.lon3_a = 'E'
      this.lat3_d = null
      this.lat3_m = null
      this.lat3_s = null
      this.lat2_a = 'N'
    },

    // 生成唯一ID
    generateUUID (len, radix) {
      const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
      const uuid = []
      let i
      radix = radix || chars.length

      if (len) {
        // Compact form
        for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)]
      } else {
        // rfc4122, version 4 form
        let r

        // rfc4122 requires these characters
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
        uuid[14] = '4'

        // Fill in random data.  At i==19 set the high bits of clock sequence as
        // per rfc4122, sec. 4.1.5
        for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | (Math.random() * 16)
            uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r]
          }
        }
      }

      return uuid.join('')
    }

  }
}
</script>

<style scoped lang="scss">
  .mycon {
    height: 150px;
  }

</style>
